module.exports = __webpack_public_path__ + "images/emoji/football.ffd5f16b6322f3ecdd5e.png";